import React from 'react';
import css from './SeoPage.module.css';
const HeroSection = ({ title, description, heroImage }) => {
  return (
    <section className={css.heroSection} data-speakable-root>
      <h1 className={css.heroTitle} data-speakable="title">{title}</h1>
      {heroImage ? (
        <div className={css.topImage}>
          <img
            src={heroImage?.url}
            alt={title || ''}
            width="1600"
            height="900"
            loading="eager"
            decoding="auto"
          />
        </div>
      ) : null}
      <p className={css.heroDescription} data-speakable="description">{description}</p>
    </section>
  );
};

export default HeroSection;
